import type { GroupBy } from 'model/types/common';

export const WIZARD_STEPS = 6;
export const APP_DEFAULT_PATH = '/home';

/** Day-range toggle options for the shared KPIs toolbar (collaboration + base sections). */
export const KPIS_DAY_OPTIONS = [7, 30, 90];

export const DEFAULT_SCORECARD_GROUP_BY: GroupBy = 'DAY';

export const CURRENCY = 'USD';
